import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex align-items-center justify-content-center text-black h-2rem mt-2 select-none"
}
const _hoisted_2 = { class: "left col-fixed p-2 bg-white" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "right col-fixed p-2 unassigned-badge" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "left col-fixed p-2 bg-white" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = {
  key: 0,
  class: "right col-fixed p-2 bg-white"
}
const _hoisted_9 = ["textContent"]

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { usePeopleStore } from '@/store';
import { can, useReferralAssignCounts } from '@/composables';
import { PERMISSIONS } from '@/enum';

/**
 * Define the people store instance and references.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'UserHeaderTotals',
  setup(__props) {

const peopleStore = usePeopleStore();
const { totals } = storeToRefs(peopleStore);
const { getTotals } = peopleStore;
const referralCounts = useReferralAssignCounts();

/**
 * Define a route instance.
 */
const route = useRoute();
/**
 * Initialize everything required to build out the component.
 */
onMounted(() => init());

/**
 * Only display the user totals within the user list.
 */
const showTotals = computed<boolean>(
  () =>
    (route.name === 'user.list' || route.name === 'students') &&
    can([PERMISSIONS.PEOPLE_TOTALS, PERMISSIONS.PEOPLE_INDEX_CONNECTED]),
);
const isUserMainPage = computed<boolean>(() => route.name === 'user.list');
const isReferralsPage = computed<boolean>(() => route.name === 'students');

/**
 * Define the total of people available.
 */
const total = computed<number>(() => totals.value.data.total);

/**
 * Define the total or active people.
 */
const active = computed<number>(() => totals.value.data.active);

/**
 * Initialize the people listing and the available types.
 */
const init = async () => {
  if (can([PERMISSIONS.PEOPLE_TOTALS, PERMISSIONS.PEOPLE_INDEX_CONNECTED])) await getTotals();
};

return (_ctx: any,_cache: any) => {
  return (showTotals.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isReferralsPage.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mr-1 text-xs font-normal" }, "Total", -1)),
                _createElementVNode("span", {
                  class: "text-sm font-bold",
                  textContent: _toDisplayString(_unref(referralCounts).total.value)
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mr-1 text-xs font-normal" }, "Unassigned", -1)),
                _createElementVNode("span", {
                  class: "text-sm font-bold",
                  textContent: _toDisplayString(_unref(referralCounts).unassignedTotal.value)
                }, null, 8, _hoisted_5)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mr-1 text-xs font-normal" }, "Total", -1)),
                _createElementVNode("span", {
                  class: "text-sm font-bold",
                  textContent: _toDisplayString(total.value)
                }, null, 8, _hoisted_7)
              ]),
              (isUserMainPage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mr-1 text-xs font-normal" }, "Active", -1)),
                    _createElementVNode("span", {
                      class: "text-sm font-bold",
                      textContent: _toDisplayString(active.value)
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]))
    : _createCommentVNode("", true)
}
}

})